import dayjs from 'dayjs'
import { useRouter } from 'next/router'
import React from 'react'

import { Button } from '@wartek-id/button'
import { Icon } from '@wartek-id/icon'
import { Text } from '@wartek-id/text'

import { useGetKeyPairValue, MILKvKeys } from 'api/microlearning/useAPIKeyValue'
import { sanitize } from 'utils/text'

type ClosingInfo = {
  enabled: boolean
  banner: {
    title: string
    subtitle: string
    buttonText: string
    url: string
  }
  closedDate: string
}

const PenutupanTopikBanner = () => {
  const router = useRouter()
  const { data: penutupanTopikData } = useGetKeyPairValue<ClosingInfo>(
    MILKvKeys.PenutupanTopik
  )
  if (!penutupanTopikData?.data) return null
  const showBanner =
    penutupanTopikData.data.enabled &&
    new Date() < new Date(penutupanTopikData.data.closedDate)
  const subtitle = penutupanTopikData.data.banner?.subtitle || ''
  return showBanner ? (
    <div className="bg-surface-default rounded-lg p-4 mb-4 mt-2 mx-3 flex gap-2">
      <Icon fontSize="sm" color="informational">
        info
      </Icon>
      <div className="flex flex-col space-y-1">
        <Text variant="body-sm-bold">
          {penutupanTopikData.data.banner.title}
        </Text>
        <div
          className="text-xs mb-2"
          dangerouslySetInnerHTML={{
            __html: sanitize(
              subtitle.replaceAll(
                '%closedDate%',
                dayjs(penutupanTopikData?.data?.closedDate).format(
                  'DD MMMM YYYY'
                )
              )
            ),
          }}
        />
        <div>
          <Button
            size="sm"
            className="mt-2"
            variant="ghost"
            onClick={() => {
              router.push(
                penutupanTopikData?.data?.banner.url || '/pelatihan-mandiri'
              )
            }}
          >
            {penutupanTopikData?.data?.banner.buttonText}
          </Button>
        </div>
      </div>
    </div>
  ) : null
}

export default PenutupanTopikBanner
